<template>
  <v-app>
    <div id="content" v-if="label_type < 5">
      <div
        :style="page_style"
        v-for="i in groups.length"
        v-bind:key="i"
        class="page"
      >
        <div
          :class="label_type == 4 && i != 0 ? 'page_content2' : 'page_content'"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <template v-if="groups[i - 1][j - 1] !== null">
            <div
              class="font-weight-bold"
              :class="label_type == 4 ? 'page--header' : 'page--header2'"
            >
              {{ groups[i - 1][j - 1].price }}
            </div>
            <div class="page--header2">
              {{
                groups[i - 1][j - 1].name &&
                groups[i - 1][j - 1].name.length > 18
                  ? groups[i - 1][j - 1].name.slice(0, 18) + ".."
                  : groups[i - 1][j - 1].name
              }}
            </div>
            <div style="margin: 0; padding: 0">
              <svg
                v-if="label_type == 4"
                :id="'barcode' + (i - 1) + '_' + (j - 1)"
                class="mx-5"
                v-bind:value="groups[i - 1][j - 1].code"
              />
              <barcode
                v-else
                v-bind:value="groups[i - 1][j - 1].code"
                :height="height"
                >Can't</barcode
              >
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 5" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 145px; margin-right: 50px"
        >
          <svg
            class="ma-0 pa-0"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          />
          <div
            style="
              display: inline;
              font-size: 13px;
              line-height: 1;
              position: absolute;
              margin-top: 10px;
            "
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            class="ma-0 pa-0 px-2"
            style="
              text-align: left;
              line-height: 1;
              width: 80mm;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>

          <v-layout row class="ma-0 pa-0">
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 40px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0 mt-2">
                <div
                  style="
                    font-size: 23px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="font-size: 20px; display: inline; line-height: 1"
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
          <p
            class="ma-0 pa-0 mr-2"
            style="text-align: right; font-weight: bold"
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 8" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page8"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 50px; margin-right: 25px"
        >
          <svg
            class="ma-0 pa-0"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          />
          <div
            style="
              display: inline;
              font-size: 20px;
              line-height: 1;
              position: absolute;
              margin-top: 13px;
            "
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            class="ma-0 pa-0 px-1"
            style="
              text-align: center;
              line-height: 1;
              width: 57mm;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: bold;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>

          <v-layout row class="ma-0 pa-0">
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 35px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0 mt-2">
                <div
                  style="
                    font-size: 18px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="font-size: 15px; display: inline; line-height: 1"
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
          <p
            class="ma-0 pa-0 mr-2"
            style="text-align: right; font-weight: bold; font-size: 10px"
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p>
        </div>
      </div>
    </div>

    <div v-else-if="label_type == 27" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page27"
        :class="i == groups.length ? '' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 50px; margin-right: 25px"
        >
          <h3 class="mb-0" style="text-align: center">Tiin</h3>
          <p
            class="mt-0 mb-2 mx-2 pa-0 px-2"
            style="
              text-align: left;
              font-size: 15px;
              border:1px solid #000
              line-height: 1; 
              width: 54mm;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>

          <v-layout
            row
            class="ml-2 mt-2 pa-0"
            style="border: 1px solid #000; margin-left: 4px; width: 54mm"
          >
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 18px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="
                    font-size: 12px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="
                    font-size: 12px;
                    font-weight: bold;
                    display: inline;
                    line-height: 1;
                  "
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-row class="ml-2" style="width: 54mm" justify="center">
            <svg
              class="ma-0 pa-0"
              :id="'barcode' + (i - 1) + '_0'"
              v-bind:value="groups[i - 1][0].code"
            />
          </v-row>
          <div
            class="ml-2 mt-3"
            style="
            text-align:center
              display: inline;
              width: 54mm;
              font-size: 10px;
              line-height: 1;
            "
            v-text="groups[i - 1][0].code"
          ></div>

          <!-- <p
            class="ma-0 pa-0 mr-2"
            style="text-align: right; font-weight: bold"
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p> -->
        </div>
      </div>
    </div>

    <div v-else-if="label_type == 26" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page8"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 50px; margin-right: 25px"
        >
          <svg
            class="ma-0 pa-0"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          />
          <div
            style="
              display: inline;
              font-size: 20px;
              line-height: 1;
              position: absolute;
              margin-top: 13px;
            "
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            class="ma-0 pa-0 px-2"
            style="
              text-align: left;
              line-height: 1;
              width: 50mm;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>

          <v-layout row class="ma-0 pa-0">
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 40px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0 mt-2">
                <div
                  style="
                    font-size: 23px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="font-size: 20px; display: inline; line-height: 1"
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
          <p
            class="ma-0 pa-0 mr-2"
            style="text-align: right; font-weight: bold"
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p>
        </div>
      </div>
    </div>

    <div v-else-if="label_type == 6" id="content" style="margin-left: -178px">
      <div class="" :class="'pa-0'">
        <div
          class="multi-price-grid-container-row multi_price_page"
          :style="page_style"
          v-for="i in groups.length"
          v-bind:key="i"
        >
          <div
            class="multi-price-grid-container-column-simple"
            :class="'ma-0 pa-0'"
          >
            <div v-if="groups[i - 1][0].prices_type == 1">
              <div
                class="multi-price-grid-container-column"
                :class="'ma-0 pa-0'"
              >
                <div>
                  Code .{{
                    groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                  }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count1">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-item-price1">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <!-- <sup style="line-height: 1.5;">{{groups[i - 1][0].price_second1}}</sup> -->
                    <span class="multi-price-price-tail1">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else-if="groups[i - 1][0].prices_type == 2">
              <div
                class="multi-price-grid-container-column"
                :class="'ma-0 pa-0'"
              >
                <div>
                  Code .{{
                    groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                  }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count2">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-item-price2">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <!-- <sup>{{groups[i - 1][0].price_second1}}</sup> -->
                    <span class="multi-price-price-tail2">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count2">
                  {{ groups[i - 1][0].from2 }}+
                </div>
                <div class="multi-price-item-price2">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first2 }}
                    <!-- <sup>{{groups[i - 1][0].price_second2}}</sup> -->
                    <span class="multi-price-price-tail2">{{
                      groups[i - 1][0].price_second2
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="multi-price-grid-container-row-simple">
              <div
                class="multi-price-grid-container-column"
                :class="'ma-0 pa-0'"
              >
                <div>
                  Code .{{
                    groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                  }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-item-price">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <span class="multi-price-price-tail">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                    <!-- <sup>{{groups[i - 1][0].price_second1}}</sup> -->
                  </span>
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count">
                  {{ groups[i - 1][0].from2 }}+
                </div>
                <div class="multi-price-item-price">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first2 }}
                    <!-- <sup>{{groups[i - 1][0].price_second2}}</sup> -->
                    <span class="multi-price-price-tail">{{
                      groups[i - 1][0].price_second2
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count">
                  {{ groups[i - 1][0].from3 }}+
                </div>
                <div class="multi-price-item-price">
                  <span
                    class="multi-price-amount"
                    style="font-size: 30px; line-height: 1"
                  >
                    {{ groups[i - 1][0].price_first3 }}
                    <!-- <sup>{{groups[i - 1][0].price_second3}}</sup> -->
                    <span class="multi-price-price-tail">{{
                      groups[i - 1][0].price_second3
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="multi-price-grid-container-row-simple">
              <div class="multi-price-item-name">
                <span
                  style="
                    display: table-cell;
                    vertical-align: middle;
                    line-height: 1.2;
                  "
                  >{{
                    groups[i - 1][0].name && groups[i - 1][0].name.length > 40
                      ? groups[i - 1][0].name.slice(0, 50)
                      : groups[i - 1][0].name
                  }}</span
                >
              </div>
              <div class="multi-price-barcode">
                <vue-qrcode
                  :value="`${groups[i - 1][0].sku}&${
                    groups[i - 1][0].last_price_change
                  }`"
                  :width="60"
                  :margin="0"
                  :scale="0"
                ></vue-qrcode>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="label_type == 25"
      id="content"
      style="margin-top: 90px; margin-left: -178px"
    >
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="multi_price_page"
        :class="'pa-0'"
        :style="page_style"
      >
        <div class="multi-price-grid-container-row">
          <div
            class="multi-price-grid-container-column-simple"
            :class="'ma-0 pa-0'"
          >
            <div v-if="groups[i - 1][0].prices_type == 1">
              <div
                class="multi-price-grid-container-column"
                :class="'ma-0 pa-0'"
              >
                <div>
                  Code .{{
                    groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                  }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count1">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-item-price1">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <!-- <sup style="line-height: 1.5;">{{groups[i - 1][0].price_second1}}</sup> -->
                    <span class="multi-price-price-tail1">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else-if="groups[i - 1][0].prices_type == 2">
              <div
                class="multi-price-grid-container-column"
                :class="'ma-0 pa-0'"
              >
                <div>
                  Code .{{
                    groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                  }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count2">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-item-price2">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <!-- <sup>{{groups[i - 1][0].price_second1}}</sup> -->
                    <span class="multi-price-price-tail2">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count2">
                  {{ groups[i - 1][0].from2 }}+
                </div>
                <div class="multi-price-item-price2">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first2 }}
                    <!-- <sup>{{groups[i - 1][0].price_second2}}</sup> -->
                    <span class="multi-price-price-tail2">{{
                      groups[i - 1][0].price_second2
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="multi-price-grid-container-row-simple">
              <div
                class="multi-price-grid-container-column"
                :class="'ma-0 pa-0'"
              >
                <div>
                  Code .{{
                    groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                  }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-item-price">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <span class="multi-price-price-tail">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                    <!-- <sup>{{groups[i - 1][0].price_second1}}</sup> -->
                  </span>
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count">
                  {{ groups[i - 1][0].from2 }}+
                </div>
                <div class="multi-price-item-price">
                  <span class="multi-price-amount">
                    {{ groups[i - 1][0].price_first2 }}
                    <!-- <sup>{{groups[i - 1][0].price_second2}}</sup> -->
                    <span class="multi-price-price-tail">{{
                      groups[i - 1][0].price_second2
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="multi-price-grid-container-column">
                <div class="multi-price-item-count">
                  {{ groups[i - 1][0].from3 }}+
                </div>
                <div class="multi-price-item-price">
                  <span
                    class="multi-price-amount"
                    style="font-size: 30px; line-height: 1"
                  >
                    {{ groups[i - 1][0].price_first3 }}
                    <!-- <sup>{{groups[i - 1][0].price_second3}}</sup> -->
                    <span class="multi-price-price-tail">{{
                      groups[i - 1][0].price_second3
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="multi-price-grid-container-row-simple">
              <div class="multi-price-item-name">
                <span
                  style="
                    display: table-cell;
                    vertical-align: middle;
                    line-height: 1.2;
                  "
                  >{{
                    groups[i - 1][0].name && groups[i - 1][0].name.length > 40
                      ? groups[i - 1][0].name.slice(0, 50)
                      : groups[i - 1][0].name
                  }}</span
                >
              </div>
              <div class="multi-price-barcode">
                <vue-qrcode
                  :value="`${groups[i - 1][0].sku}&${
                    groups[i - 1][0].last_price_change
                  }`"
                  :width="60"
                  :margin="0"
                  :scale="0"
                ></vue-qrcode>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="label_type == 7"
      id="content"
      style="margin-top: 40px; margin-left: -37px"
    >
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="label_4x_page"
        :class="'pa-0'"
        :style="page_style"
      >
        <div
          class="label-4x-row"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <div class="label-4x-row-name">
            {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].name : "" }}
          </div>
          <div class="label-4x-row-barcode">
            <svg
              v-if="groups[i - 1][j - 1]"
              style="margin: 0; padding: 0"
              :id="'barcode' + (i - 1) + '_' + (j - 1)"
              v-bind:value="groups[i - 1][j - 1].code"
            />
           <!-- <div>
                  {{
                    groups[i - 1][j - 1] ? groups[i - 1][j - 1].barcode : ""
                  }}
                </div> -->
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 9" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="page"
        :style="page_style"
      >
        <div
          class="multi-godex-body"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <div class="multi-godex-body-left" v-if="groups[i - 1][j - 1]">
            <div class="multi-godex-body-left-name">
              {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].name : "" }}
            </div>
            <div class="multi-godex-body-left-sku">
              {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].sku : "" }}
            </div>
            <div class="multi-godex-body-left-date">
              {{ date_ddmmyy(new Date().getTime()) }}
            </div>
          </div>
          <div class="multi-godex-body-right" v-if="groups[i - 1][j - 1]">
            <div class="multi-godex-body-right-price">
              <v-layout row class="ma-0 pa-0">
                <v-flex class="text-right pr-1">
                  <div
                    style="font-size: 40px; display: inline; font-weight: bold"
                    v-text="
                      groups[i - 1][j - 1]
                        ? groups[i - 1][j - 1].price_first
                        : ''
                    "
                  ></div>
                </v-flex>
                <v-flex>
                  <v-layout row class="ma-0 pa-0 mt-2">
                    <div
                      style="
                        font-size: 23px;
                        display: inline;
                        font-weight: bold;
                        line-height: 1;
                      "
                      v-text="
                        groups[i - 1][j - 1]
                          ? groups[i - 1][j - 1].price_second
                          : ''
                      "
                    ></div>
                  </v-layout>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="font-size: 20px; display: inline; line-height: 1"
                      v-text="'сум'"
                    ></div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div class="multi-godex-body-right-barcode">
              <svg
                v-if="groups[i - 1][j - 1]"
                style="margin: 0; padding: 0"
                :id="'barcode' + (i - 1) + '_' + (j - 1)"
                v-bind:value="
                  groups[i - 1][j - 1] ? groups[i - 1][j - 1].code : ''
                "
              />
            </div>
          </div>
        </div>
        <!-- <div class="label-4x-row" v-for="j in groups[i - 1].length" v-bind:key="i + '_' + j">
          <div class="label-4x-row-name">{{groups[i - 1][j - 1] ? groups[i - 1][j - 1].name : ''}}</div>
          <div class="label-4x-row-barcode">
            <svg
              v-if="groups[i - 1][j - 1]"
              style="margin: 0; padding: 0"
              :id="'barcode'+(i-1)+'_'+(j-1)"
              v-bind:value="groups[i - 1][j - 1].code"
            />
          </div>
        </div>-->
      </div>
    </div>
    <div id="content" v-else-if="label_type == 10">
      <div
        :style="page_style"
        v-for="i in groups.length"
        v-bind:key="i"
        class="page"
      >
        <div
          :class="'page_content'"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <template v-if="groups[i - 1][j - 1] !== null">
            <div
              class="font-weight-bold"
              :class="'page--header2'"
              style="margin-top: 8px"
            >
              {{ groups[i - 1][j - 1].price }}
            </div>
            <div class="page--header2">
              {{
                groups[i - 1][j - 1].name &&
                groups[i - 1][j - 1].name.length > 18
                  ? groups[i - 1][j - 1].name.slice(0, 18) + ".."
                  : groups[i - 1][j - 1].name
              }}
            </div>
            <div style="margin: 0; padding: 0; text-align: center">
              <vue-qrcode
                :value="`${groups[i - 1][0].code}`"
                :width="60"
                :margin="0"
                :scale="0"
              ></vue-qrcode>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div id="content" v-else-if="label_type == 11">
      <div
        :style="page_style"
        v-for="i in groups.length"
        v-bind:key="i"
        class="page"
      >
        <div
          :class="'page_content2'"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <template v-if="groups[i - 1][j - 1] !== null">
            <div class="text-center">
              <div
                class="font-weight-medium ma-0 pa-0"
                style="
                  margin-top: 5px;
                  max-width: 28mm;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: center;
                  font-size: 12px;
                  margin-bottom: 0;
                "
              >
                {{ service_name }}
              </div>
            </div>
            <div class="page--header font-weight-bold" style="font-size: 21px">
              {{ groups[i - 1][j - 1].price }}
            </div>
            <div class="text-center">
              <div
                style="
                  max-width: 30mm;
                  min-height: 8mm;
                  overflow-wrap: break-word;
                  overflow: hidden;
                  font-size: 12px;
                "
              >
                {{
                  groups[i - 1][j - 1].name &&
                  groups[i - 1][j - 1].name.length > 14
                    ? groups[i - 1][j - 1].name.slice(0, 14) + ".."
                    : groups[i - 1][j - 1].name
                }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 12" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page12"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative; margin-right: 25px">
          <svg
            class="ma-0 pa-0"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          />
          <div
            style="
              display: inline;
              font-size: 20px;
              line-height: 1;
              position: absolute;
              margin-top: 15px;
            "
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            class="ma-0 pa-0 px-2"
            style="
              text-align: left;
              line-height: 1;
              width: 50mm;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>

          <v-layout row class="ma-0 pa-0">
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 40px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0 mt-2">
                <div
                  style="
                    font-size: 23px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="font-size: 20px; display: inline; line-height: 1"
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
          <p
            class="ma-0 pa-0 mr-2"
            style="text-align: right; font-weight: bold"
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 13">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page13"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div class="rotate90" style="position: relative">
          <div class="category_name_and_sku_13">
            <div class="category_name_13" style="font-weight: 500">
              {{ groups[i - 1][0].category_name }}
            </div>
            <div class="sku_13" style="text-align: right">
              {{ groups[i - 1][0].sku }}
            </div>
          </div>
          <div class="item_name_13">
            {{ groups[i - 1][0].name }}
          </div>
          <div class="item_price_13">
            <v-layout row class="ma-0 pa-0">
              <v-flex class="text-right pr-1">
                <div
                  style="font-size: 25px; display: inline; font-weight: bold"
                  v-text="groups[i - 1][0].price_first"
                ></div>
              </v-flex>
              <v-flex>
                <v-layout row class="ma-0 pa-0">
                  <div
                    style="
                      font-size: 20px;
                      display: inline;
                      font-weight: bold;
                      line-height: 1;
                    "
                    v-text="groups[i - 1][0].price_second"
                  ></div>
                </v-layout>
                <v-layout row class="ma-0 pa-0">
                  <div
                    style="font-size: 15px; display: inline; line-height: 1"
                    v-text="'сум'"
                  ></div>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div class="item_footer_13">
            <div>
              <svg
                class="ma-0 pa-0"
                :id="'barcode' + (i - 1) + '_0'"
                v-bind:value="groups[i - 1][0].code"
              />
            </div>
            <div style="text-align: right; margin-top: 4mm">
              {{ date_ddmmyy(new Date().getTime()) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 14">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page14"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative">
          <div class="category_name_and_sku_14">
            <div class="category_name_14" style="font-weight: 500">
              {{ groups[i - 1][0].category_name }}
            </div>
            <div class="sku_14" style="text-align: right">
              {{ groups[i - 1][0].sku }}
            </div>
          </div>
          <div class="item_name_14">
            {{ groups[i - 1][0].name }}
          </div>
          <div class="item_footer_14">
            <div class="item_footer_left_14">
              <div class="item_footer_left_date_14">
                {{ date_ddmmyy(new Date().getTime()) }}
              </div>
              <div class="item_footer_left_barcode_14">
                <svg
                  class="ma-0 pa-0"
                  :id="'barcode' + (i - 1) + '_0'"
                  v-bind:value="groups[i - 1][0].code"
                />
              </div>
            </div>
            <div class="item_footer_right_14" style="text-align: right">
              <v-layout row class="ma-0 pa-0 mt-2">
                <v-flex class="text-right pr-1">
                  <div
                    style="font-size: 25px; display: inline; font-weight: bold"
                    v-text="groups[i - 1][0].price_first"
                  ></div>
                </v-flex>
                <v-flex>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="
                        font-size: 20px;
                        display: inline;
                        font-weight: bold;
                        line-height: 1;
                      "
                      v-text="groups[i - 1][0].price_second"
                    ></div>
                  </v-layout>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="font-size: 15px; display: inline; line-height: 1"
                      v-text="'сум'"
                    ></div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 15">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page15"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative">
          <div class="category_name_and_sku_15">
            <div class="category_name_15" style="font-weight: 500">
              {{ groups[i - 1][0].category_name }}
            </div>
            <div class="sku_15" style="text-align: right">
              {{ groups[i - 1][0].sku }}
            </div>
          </div>
          <div class="item_name_15">
            {{ groups[i - 1][0].name }}
          </div>
          <div class="item_footer_15">
            <div class="item_footer_left_15">
              <div class="item_footer_left_date_15">
                {{ date_ddmmyy(new Date().getTime()) }}
              </div>
              <div class="item_footer_left_barcode_15">
                <svg
                  class="ma-0 pa-0"
                  :id="'barcode' + (i - 1) + '_0'"
                  v-bind:value="groups[i - 1][0].code"
                />
              </div>
            </div>
            <div class="item_footer_right_15" style="text-align: right">
              <v-layout row class="ma-0 pa-0 mt-2">
                <v-flex class="text-right pr-1">
                  <div
                    style="font-size: 20px; display: inline; font-weight: bold"
                    v-text="groups[i - 1][0].price_first"
                  ></div>
                </v-flex>
                <v-flex>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="
                        font-size: 15px;
                        display: inline;
                        font-weight: bold;
                        line-height: 1;
                      "
                      v-text="groups[i - 1][0].price_second"
                    ></div>
                  </v-layout>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="font-size: 15px; display: inline; line-height: 1"
                      v-text="'сум'"
                    ></div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 16">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page15"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative">
          <div class="category_name_and_sku_15">
            <div class="category_name_16" style="font-weight: 700">
              {{ groups[i - 1][0].price }}
            </div>
            <div class="sku_15" style="text-align: right">
              {{ groups[i - 1][0].sku }}
            </div>
          </div>
          <div class="item_name_15">
            {{ groups[i - 1][0].name }}
          </div>
          <div class="item_footer_15">
            <!-- <div class="item_footer_left_16"> -->
            <!-- <div class="item_footer_left_date_16">
                {{ date_ddmmyy(new Date().getTime()) }}
              </div> -->
            <div class="item_footer_left_barcode_16">
              <svg
                class="ma-0 pa-0"
                :id="'barcode' + (i - 1) + '_0'"
                v-bind:value="groups[i - 1][0].code"
              />
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 17" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="page"
        :style="page_style"
      >
        <div
          class="multi-godex-body-3-7"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <div class="multi-godex-body-left-3-7" v-if="groups[i - 1][j - 1]">
            <div class="multi-godex-body-left-name-3-7">
              <!-- <div class="multi-godex-body-left-name-3-7-vertical-center"> -->
              {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].name : "" }}
              <!-- </div>  -->
            </div>
            <div class="multi-godex-body-left-sku-3-7">
              {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].sku : "" }}
            </div>
          </div>
          <div class="multi-godex-body-right-3-7" v-if="groups[i - 1][j - 1]">
            <div class="multi-godex-body-right-price-3-7">
              <v-layout row class="ma-0 pa-0">
                <v-flex class="text-right pr-1">
                  <div
                    style="font-size: 40px; display: inline; font-weight: bold"
                    v-text="
                      groups[i - 1][j - 1]
                        ? groups[i - 1][j - 1].price_first
                        : ''
                    "
                  ></div>
                </v-flex>
                <v-flex>
                  <v-layout row class="ma-0 pa-0 mt-2">
                    <div
                      style="
                        font-size: 30px;
                        display: inline;
                        font-weight: bold;
                        line-height: 1;
                      "
                      v-text="
                        groups[i - 1][j - 1]
                          ? groups[i - 1][j - 1].price_second
                          : ''
                      "
                    ></div>
                  </v-layout>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="font-size: 25px; display: inline; line-height: 1"
                      v-text="'сум'"
                    ></div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div class="multi-godex-body-right-barcode-3-7">
              <svg
                v-if="groups[i - 1][j - 1]"
                style="margin: 0; padding: 0"
                :id="'barcode' + (i - 1) + '_' + (j - 1)"
                v-bind:value="
                  groups[i - 1][j - 1] ? groups[i - 1][j - 1].code : ''
                "
              />
            </div>
          </div>
        </div>
        <!-- <div class="label-4x-row" v-for="j in groups[i - 1].length" v-bind:key="i + '_' + j">
          <div class="label-4x-row-name">{{groups[i - 1][j - 1] ? groups[i - 1][j - 1].name : ''}}</div>
          <div class="label-4x-row-barcode">
            <svg
              v-if="groups[i - 1][j - 1]"
              style="margin: 0; padding: 0"
              :id="'barcode'+(i-1)+'_'+(j-1)"
              v-bind:value="groups[i - 1][j - 1].code"
            />
          </div>
        </div>-->
      </div>
    </div>
    <div v-else-if="label_type == 18" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="multi_price_small_page"
        :class="'pa-0'"
        :style="page_style"
      >
        <div class="multi-price-small-grid-container-row">
          <div
            class="multi-price-small-grid-container-column-simple"
            :class="'ma-0 pa-0'"
          >
            <div v-if="groups[i - 1][0].prices_type == 1">
              <div
                class="multi-price-small-grid-container-column"
                :class="'ma-0 pa-0'"
                style="font-size: 10px; line-height: 2.5; max-height: 24px"
              >
                <div>
                  Code {{ groups[i - 1][0] ? groups[i - 1][0].sku : "" }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-small-grid-container-column">
                <div class="multi-price-small-item-count1">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-small-item-price1">
                  <span class="multi-price-small-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <span class="multi-price-small-price-tail1">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else-if="groups[i - 1][0].prices_type == 2">
              <div
                class="multi-price-small-grid-container-column"
                :class="'ma-0 pa-0'"
                style="font-size: 10px; line-height: 2.5; max-height: 23.4px"
              >
                <div>
                  Code {{ groups[i - 1][0] ? groups[i - 1][0].sku : "" }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-small-grid-container-column">
                <div class="multi-price-small-item-count2">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-small-item-price2">
                  <span class="multi-price-small-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <span class="multi-price-small-price-tail2">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="multi-price-small-grid-container-column">
                <div class="multi-price-small-item-count2">
                  {{ groups[i - 1][0].from2 }}+
                </div>
                <div class="multi-price-small-item-price2">
                  <span class="multi-price-small-amount">
                    {{ groups[i - 1][0].price_first2 }}
                    <span class="multi-price-small-price-tail2">{{
                      groups[i - 1][0].price_second2
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="multi-price-small-grid-container-row-simple">
              <div
                class="multi-price-small-grid-container-column"
                :class="'ma-0 pa-0'"
                style="font-size: 10px; line-height: 2.5; max-height: 26px"
              >
                <div>
                  Code {{ groups[i - 1][0] ? groups[i - 1][0].sku : "" }}
                </div>
                <div style="text-align: right; padding-right: 0.5mm">
                  {{ date_ddmmyy(new Date().getTime()) }}
                </div>
              </div>
              <div class="multi-price-small-grid-container-column">
                <div class="multi-price-small-item-count">
                  {{ groups[i - 1][0].from1 }}+
                </div>
                <div class="multi-price-small-item-price">
                  <span class="multi-price-small-amount">
                    {{ groups[i - 1][0].price_first1 }}
                    <span class="multi-price-small-price-tail">{{
                      groups[i - 1][0].price_second1
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="multi-price-small-grid-container-column">
                <div class="multi-price-small-item-count">
                  {{ groups[i - 1][0].from2 }}+
                </div>
                <div class="multi-price-small-item-price">
                  <span class="multi-price-small-amount">
                    {{ groups[i - 1][0].price_first2 }}
                    <span class="multi-price-small-price-tail">
                      {{ groups[i - 1][0].price_second2 }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="multi-price-small-grid-container-column">
                <div class="multi-price-small-item-count">
                  {{ groups[i - 1][0].from3 }}+
                </div>
                <div class="multi-price-small-item-price">
                  <span
                    class="multi-price-small-amount"
                    style="font-size: 30px; line-height: 1"
                  >
                    {{ groups[i - 1][0].price_first3 }}
                    <span class="multi-price-small-price-tail">
                      {{ groups[i - 1][0].price_second3 }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="multi-price-small-grid-container-row-simple">
              <div class="multi-price-small-item-name">
                <div class="multi-price-small-item-name-box">
                  <span
                    style="
                      display: table-cell;
                      vertical-align: middle;
                      line-height: 0.825;
                    "
                    >{{
                      groups[i - 1][0].name && groups[i - 1][0].name.length > 40
                        ? groups[i - 1][0].name.slice(0, 50)
                        : groups[i - 1][0].name
                    }}
                  </span>
                </div>
              </div>
              <div class="multi-price-small-barcode">
                <vue-qrcode
                  :value="`${groups[i - 1][0].sku}`"
                  :width="60"
                  :margin="0"
                  :scale="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="label_type == 19"
      id="content"
      style="margin-top: 40px; margin-left: -32px"
    >
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="label_4x_page"                                                                                             
        :class="'pa-0'"
        :style="page_style"
      >                                                                                                                                                                                                                                                                                                                                                           
        <div
          class="label-4x-row"
          style="border: solid green 0.5px"
          v-for="j in groups[i - 1].length"
          v-bind:key="i + '_' + j"
        >
          <div class="label-4x-item-name">
            <div
              class="label-4x-item-name-own"
              :style="`line-height: ${getLineHeightOfItem(
                groups[i - 1][j - 1]                                                               
              )}`"                                                      
            >
              {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].sku + "-" : "" }}
              {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].name : "" }}
            </div>
          </div>
          <div class="label-4x-item-barcode">
            <!-- <div                                                             
              v-if="groups[i - 1][j - 1]"
              style="font-family: 'Libre Barcode 39'; margin: 0; padding: 0; font-size: 1.875em; font-weight: 10; text-opasity: 0.5;"
            >
              {{ groups[i - 1][j - 1].code }}
            </div> -->
            <!-- <div style=" display: none;"> -->
            <svg
              v-if="groups[i - 1][j - 1]"
              style="margin: 0; padding: 0"
              :id="'barcode' + (i - 1) + '_' + (j - 1)"
              v-bind:value="groups[i - 1][j - 1].code"
            />
            <!-- </div> -->
          </div>
          <div class="label-4x-item-price">
            {{ groups[i - 1][j - 1] ? groups[i - 1][j - 1].price : "" }}
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 20">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page20"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative">
          <div class="item_name_20">
            <div class="item_name_20_box">
              <span class="item_name_20_snap">
                {{ groups[i - 1][0].name }}
              </span>
            </div>
          </div>
          <div class="item_footer_left_barcode_20">
            <svg
              class="ma-0 pa-0"
              :id="'barcode' + (i - 1) + '_0'"
              v-bind:value="groups[i - 1][0].code"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 21" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page8"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 50px; margin-right: 25px"
        >
          <div style="display: none">
            <svg
              class="ma-0 pa-0"
              :id="'barcode' + (i - 1) + '_0'"
              v-bind:value="groups[i - 1][0].code"
            />
          </div>
          <div class="small-page-name-box">
            <div class="small-page-name">
              <span
                style="
                  display: table-cell;
                  vertical-align: middle;
                  line-height: 1.4;
                "
                >{{ groups[i - 1][0].name }}
              </span>
            </div>
          </div>

          <v-layout row class="ma-0 pa-0">
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 38px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0 mt-2">
                <div
                  style="
                    font-size: 21px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="font-size: 18px; display: inline; line-height: 1"
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
          <div
            style="display: inline; position: absolute"
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            class="ma-0 pa-0 mr-2"
            style="text-align: right; font-weight: bold"
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 22">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page22"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative">
          <div class="item_name_22" style="padding-left: 0; padding-right: 0; padding-top: 0mm; padding-bottom: 0; min-height: 14mm; max-height: 14mm;">
            <div class="item_name_22_box">
              <span class="item_name_22_snap">
                {{ groups[i - 1][0].name }}
              </span>
            </div>
          </div>
          <div class="item_footer_left_barcode_22" style="padding-left: 0; padding-right: 0; padding-top: 1mm; padding-bottom: 0; min-height: 7mm; max-height: 7mm; padding-bottom: 1mm; margin-bottom: 1mm; overflow: hidden;">
            <svg
              class="ma-0 pa-0"
              style="height: 18px;"
              :id="'barcode' + (i - 1) + '_0'"
              v-bind:value="groups[i - 1][0].code"
            />
          </div>

          <div class="sku_22" style="display: flex; justify-content: space-between; align-items: flex-end; padding-left: 1mm; padding-right: 2mm;">
            <span>{{ groups[i - 1][0].sku }}</span>
            <span v-if="groups[i - 1][0].price !== 0" style="font-size: 16px; padding-left: 10px;">{{ groups[i - 1][0].price }}</span>
          </div>
          <!-- <div class="category_name_and_sku_14">
            <div class="category_name_14" style="font-weight: 500">
              {{ groups[i - 1][0].category_name }}
            </div>
          </div>
          <div class="item_name_14">
            {{ groups[i - 1][0].name }}
          </div>
          <div class="item_footer_14">
            <div class="item_footer_left_14">
              <div class="item_footer_left_date_14">
                {{ date_ddmmyy(new Date().getTime()) }}
              </div>
              <div class="item_footer_left_barcode_14">
                <svg
                  class="ma-0 pa-0"
                  :id="'barcode' + (i - 1) + '_0'"
                  v-bind:value="groups[i - 1][0].code"
                />
              </div>
            </div>
            <div class="item_footer_right_14" style="text-align: right">
              <v-layout row class="ma-0 pa-0 mt-2">
                <v-flex class="text-right pr-1">
                  <div
                    style="font-size: 25px; display: inline; font-weight: bold"
                    v-text="groups[i - 1][0].price_first"
                  ></div>
                </v-flex>
                <v-flex>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="
                        font-size: 20px;
                        display: inline;
                        font-weight: bold;
                        line-height: 1;
                      "
                      v-text="groups[i - 1][0].price_second"
                    ></div>
                  </v-layout>
                  <v-layout row class="ma-0 pa-0">
                    <div
                      style="font-size: 15px; display: inline; line-height: 1"
                      v-text="'сум'"
                    ></div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 23">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page22"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div style="position: relative">
          <div class="item_name_22">
            <div class="item_name_22_box">
              <span class="item_name_22_snap">
                {{ groups[i - 1][0].sku }}-{{ groups[i - 1][0].name }}
              </span>
            </div>
          </div>
          <div class="item_footer_left_barcode_22">
            <vue-qrcode
              :value="`${groups[i - 1][0].code}`"
              :width="60"
              :margin="0"
              :scale="0"
            />
            <!-- <svg
              class="ma-0 pa-0"
              :id="'barcode' + (i - 1) + '_0'"
              v-bind:value="groups[i - 1][0].code"
            /> -->
          </div>

          <div class="sku_22">
            <!-- {{ groups[i - 1][0].sku }} -->
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="label_type == 28">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page28"
        :class="i == groups.length ? '' : ''"
        :style="page_style"
      >
        <div style="position: relative; height: 18mm">
          <p
            class="mt-1"
            style="
              text-align: center;
              font-size: 11px;
              line-height: 1;
              width: 30mm;
              font-weight: bold;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>
          <div class="mb-0 pb-0" style="position: absolute; bottom: 0">
            <v-row
              class="mt-1 mb-0 mx-auto"
              style="width: 26mm"
              justify="center"
            >
              <svg
                class="ma-0 pa-0"
                :id="'barcode' + (i - 1) + '_0'"
                v-bind:value="groups[i - 1][0].code"
              />
            </v-row>
            <div
              class="mx-auto mt-0"
              style="
            text-align:center
              display: inline;
              width: 30mm;
              font-size: 10px;
              line-height: 1;
            "
              v-text="groups[i - 1][0].code"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="label_type == 29" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page8"
        :class="i == groups.length ? 'bottom_border' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 50px; margin-right: 25px"
        >
          <svg
            class="ma-0 pa-0"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          />
          <div
            style="
              display: inline;
              font-size: 20px;
              line-height: 1;
              position: absolute;
              margin-top: 13px;
            "
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            class="ma-0 pa-0 px-1"
            style="
              text-align: center;
              line-height: 1;
              width: 57mm;
              font-size: 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: bold;
            "
          >
            {{ groups[i - 1][0].name }}
          </p>

          <v-layout row class="ma-0 mt-2 pa-0">
            <v-flex class="text-right pr-1">
              <div
                style="font-size: 35px; display: inline; font-weight: bold"
                v-text="groups[i - 1][0].price_first"
              ></div>
            </v-flex>
            <v-flex>
              <v-layout row class="ma-0 pa-0 mt-2">
                <div
                  style="
                    font-size: 18px;
                    display: inline;
                    font-weight: bold;
                    line-height: 1;
                  "
                  v-text="groups[i - 1][0].price_second"
                ></div>
              </v-layout>
              <v-layout row class="ma-0 pa-0">
                <div
                  style="font-size: 15px; display: inline; line-height: 1"
                  v-text="'сум'"
                ></div>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
    <!-- <div v-else-if="label_type == 30" id="content" style="margin-top: 13px">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page30"
        :class="i == groups.length ? '' : ''"
        :style="page_style"
      >
        <div>
          <svg
            class="pa-0 mt-n2"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          />
          <div
            style="
              display: inline;
              font-size: 15px;
              line-height: 1;
              position: absolute;
              margin-top: 8px;
            "
            v-text="groups[i - 1][0].code"
          ></div>
          <p
            style="
              text-align: center;
              font-size: 14px;
              line-height: 1;
              margin-bottom: 2px;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: 700;
              padding: 0 3%;
              height: 43px;
              min-height: 20px;
              margin-top: -8px;
            "
          >
            <strong>
              {{ groups[i - 1][0].name }}
            </strong>
          </p>
          <p
            style="
              font-size: 10px;
              text-align: right;
              margin-top: -5px;
              margin-bottom: 5px;
              padding-right: 5px;
            "
          >
            {{ date_ddmmyy(new Date().getTime()) }}
          </p>

          <table
            style="
              width: 55mm;
              text-align: center;
              border-collapse: collapse;
              border-style: dashed;
              margin-top: auto;
              margin-left: 9px;
              bottom: 0;
              height: 45px !important;
            "
            border="1"
          >
            <thead>
              <tr style="width: 100%">
                <th
                  v-if="groups[i - 1][0].from2 || groups[i - 1][0].from3"
                  style="font-size: 10px"
                >
                  {{ groups[i - 1][0].from1 }}+
                </th>
                <th
                  v-if="
                    groups[i - 1][0].from2 != 0 &&
                    groups[i - 1][0].from2 > groups[i - 1][0].from1
                  "
                  style="font-size: 12px"
                >
                  {{ groups[i - 1][0].from2 }}+
                </th>
                <th
                  v-if="
                    groups[i - 1][0].from3 != 0 &&
                    groups[i - 1][0].from3 > groups[i - 1][0].from1
                  "
                  style="font-size: 14px"
                >
                  {{ groups[i - 1][0].from3 }}+
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style="
                      padding: 2px 0;
                      display: flex;
                      gap: 2px;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <p style="font-size: 18px; font-weight: 700; margin: 0">
                      {{ groups[i - 1][0].price_first1 }}
                    </p>
                    <span
                      style="
                        line-height: 0.8;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >{{ groups[i - 1][0].price_second1 }} <br />сум</span
                    >
                  </div>
                </td>
                <td
                  v-if="
                    groups[i - 1][0].from2 != 0 &&
                    groups[i - 1][0].from2 > groups[i - 1][0].from1
                  "
                >
                  <div
                    style="
                      display: flex;
                      gap: 2px;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <p style="font-size: 20px; font-weight: 700; margin: 0">
                      {{ groups[i - 1][0].price_first2 }}
                    </p>
                    <span
                      style="
                        line-height: 0.8;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >{{ groups[i - 1][0].price_second2 }} <br />сум</span
                    >
                  </div>
                </td>
                <td
                  v-if="
                    groups[i - 1][0].from3 != 0 &&
                    groups[i - 1][0].from3 > groups[i - 1][0].from1
                  "
                >
                  <div
                    style="
                      display: flex;
                      gap: 2px;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <p style="font-size: 22px; font-weight: 700; margin: 0">
                      {{ groups[i - 1][0].price_first3 }}
                    </p>
                    <span
                      style="
                        line-height: 0.8;
                        font-size: 11px;
                        font-weight: 500;
                      "
                      >{{ groups[i - 1][0].price_second3 }} <br />сум</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->

    <div v-else-if="label_type == 31" id="content">
      <div
        v-for="i in groups.length"
        v-bind:key="i"
        class="small_page27"
        :class="i == groups.length ? '' : ''"
        :style="page_style"
      >
        <div
          class="rotate90"
          style="position: relative; margin-top: 50px; margin-right: 25px"
        >
          <!-- <svg
            class="pa-0 mt-n2"
            :id="'barcode' + (i - 1) + '_0'"
            v-bind:value="groups[i - 1][0].code"
          /> -->
          <div
            style="
              font-size: 14px;
              margin-bottom: -4px;
              margin-left: 9px;
              display: flex;
              justify-content: space-between;
            "
          >
            <b style="text-align: left">
              {{ groups[i - 1][0].code }}
            </b>
            <b style="text-align: right; transform: translateX(15px)">
              {{ date_ddmmyy(new Date().getTime()) }}
            </b>
          </div>
          <p
            :style="
              groups[i - 1][0].name.length < 33
                ? 'display: flex; align-items: center;justify-content: center;text-align: center;font-size: 14px;line-height: 1;margin-bottom: 2px;overflow: hidden;text-overflow: ellipsis;font-weight: 700;padding: 0 5%;height: 56px;transform: translateX(16px);'
                : 'text-align: center;font-size: 14px;line-height: 1;margin-bottom: 2px;overflow: hidden;text-overflow: ellipsis;font-weight: 700;padding: 0 5%;height: 56px;transform: translateX(16px);'
            "
          >
            <strong>
              {{ groups[i - 1][0].name }}
            </strong>
          </p>

          <div style="width: 56mm">
            <table
              style="
                width: 55mm;
                text-align: center;
                border-collapse: collapse;
                border-style: solid;
                margin-top: 8px;
                margin-left: 9px;
                bottom: 0;
                height: 45px !important;
                border-color: black;
              "
              border="1"
            >
              <thead>
                <tr style="width: 100%">
                  <th
                    v-if="groups[i - 1][0].from2 || groups[i - 1][0].from3"
                    style="font-size: 16px"
                  >
                    {{ groups[i - 1][0].from1 }}+
                  </th>
                  <th
                    v-if="
                      groups[i - 1][0].from2 != 0 &&
                      groups[i - 1][0].from2 > groups[i - 1][0].from1
                    "
                    style="font-size: 16px"
                  >
                    {{ groups[i - 1][0].from2 }}+
                  </th>
                  <th
                    v-if="
                      groups[i - 1][0].from3 != 0 &&
                      groups[i - 1][0].from3 > groups[i - 1][0].from1
                    "
                    style="font-size: 16px"
                  >
                    {{ groups[i - 1][0].from3 }}+
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div
                      style="
                        padding: 2px 0;
                        display: flex;
                        gap: 2px;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <p style="font-size: 18px; font-weight: 700; margin: 0">
                        {{ groups[i - 1][0].price_first1 }}
                      </p>
                      <span
                        style="
                          line-height: 0.8;
                          font-size: 11px;
                          font-weight: 500;
                        "
                        >{{ groups[i - 1][0].price_second1 }} <br />сум</span
                      >
                    </div>
                  </td>
                  <td
                    v-if="
                      groups[i - 1][0].from2 != 0 &&
                      groups[i - 1][0].from2 > groups[i - 1][0].from1
                    "
                  >
                    <div
                      style="
                        display: flex;
                        gap: 2px;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <p style="font-size: 20px; font-weight: 700; margin: 0">
                        {{ groups[i - 1][0].price_first2 }}
                      </p>
                      <span
                        style="
                          line-height: 0.8;
                          font-size: 11px;
                          font-weight: 500;
                        "
                        >{{ groups[i - 1][0].price_second2 }} <br />сум</span
                      >
                    </div>
                  </td>
                  <td
                    v-if="
                      groups[i - 1][0].from3 != 0 &&
                      groups[i - 1][0].from3 > groups[i - 1][0].from1
                    "
                  >
                    <div
                      style="
                        display: flex;
                        gap: 2px;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <p style="font-size: 22px; font-weight: 700; margin: 0">
                        {{ groups[i - 1][0].price_first3 }}
                      </p>
                      <span
                        style="
                          line-height: 0.8;
                          font-size: 11px;
                          font-weight: 500;
                        "
                        >{{ groups[i - 1][0].price_second3 }} <br />сум</span
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-else-if="label_type == 32">
      <div
        class="multi-price-grid-container-col32 multi_price_page32"
        :style="page_style"
        v-for="i in groups.length"
        v-bind:key="i"
      >
        <div
          id="lab32"
          class="multi-price-grid-container-column-simple32"
          :class="'ma-0 pa-0'"
        >
          <div v-if="groups[i - 1][0].prices_type == 1">
            <div class="multi-price-grid-container-column" :class="'ma-0 pa-0'">
              <div>
                Code .{{
                  groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                }}
              </div>
              <div
                style="text-align: right; padding-right: 0.5mm color:whiet !important"
              >
                {{ date_ddmmyy(new Date().getTime()) }}
              </div>
            </div>
            <div class="multi-price-grid-container-column">
              <div class="multi-price-item-count1">
                {{ groups[i - 1][0].from1 }}+
              </div>
              <div class="multi-price-item-price1">
                <span class="multi-price-amount">
                  {{ groups[i - 1][0].price_first1 }}
                  <span class="multi-price-price-tail1">{{
                    groups[i - 1][0].price_second1
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div v-else-if="groups[i - 1][0].prices_type == 2">
            <div class="multi-price-grid-container-column" :class="'ma-0 pa-0'">
              <div>
                Code .{{
                  groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                }}
              </div>
              <div style="text-align: right; padding-right: 0.5mm">
                {{ date_ddmmyy(new Date().getTime()) }}
              </div>
            </div>
            <div class="multi-price-grid-container-column">
              <div class="multi-price-item-count2">
                {{ groups[i - 1][0].from1 }}+
              </div>
              <div class="multi-price-item-price2">
                <span class="multi-price-amount">
                  {{ groups[i - 1][0].price_first1 }}
                  <span class="multi-price-price-tail2">{{
                    groups[i - 1][0].price_second1
                  }}</span>
                </span>
              </div>
            </div>
            <div class="multi-price-grid-container-column">
              <div class="multi-price-item-count2">
                {{ groups[i - 1][0].from2 }}+
              </div>
              <div class="multi-price-item-price2">
                <span class="multi-price-amount">
                  {{ groups[i - 1][0].price_first2 }}
                  <span class="multi-price-price-tail2">{{
                    groups[i - 1][0].price_second2
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div v-else class="multi-price-grid-container-row-simple">
            <div class="multi-price-grid-container-column" :class="'ma-0 pa-0'">
              <div>
                Code .{{
                  groups[i - 1][0] ? groups[i - 1][0].barcode.slice(-5) : ""
                }}
              </div>
              <div style="text-align: right; padding-right: 0.5mm">
                {{ date_ddmmyy(new Date().getTime()) }}
              </div>
            </div>
            <div class="multi-price-grid-container-column">
              <div class="multi-price-item-count">
                {{ groups[i - 1][0].from1 }}+
              </div>
              <div class="multi-price-item-price">
                <span class="multi-price-amount">
                  {{ groups[i - 1][0].price_first1 }}
                  <span class="multi-price-price-tail">{{
                    groups[i - 1][0].price_second1
                  }}</span>
                </span>
              </div>
            </div>
            <div class="multi-price-grid-container-column">
              <div class="multi-price-item-count">
                {{ groups[i - 1][0].from2 }}+
              </div>
              <div class="multi-price-item-price">
                <span class="multi-price-amount">
                  {{ groups[i - 1][0].price_first2 }}
                  <span class="multi-price-price-tail">{{
                    groups[i - 1][0].price_second2
                  }}</span>
                </span>
              </div>
            </div>
            <div class="multi-price-grid-container-column">
              <div class="multi-price-item-count">
                {{ groups[i - 1][0].from3 }}+
              </div>
              <div class="multi-price-item-price">
                <span
                  class="multi-price-amount"
                  style="font-size: 30px; line-height: 1"
                >
                  {{ groups[i - 1][0].price_first3 }}
                  <span class="multi-price-price-tail">{{
                    groups[i - 1][0].price_second3
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="multi-price-grid-container-row-simple">
            <div class="multi-price-item-name">
              <span
                style="
                  display: table-cell;
                  vertical-align: middle;
                  line-height: 1.2;
                "
                >{{
                  groups[i - 1][0].name && groups[i - 1][0].name.length > 40
                    ? groups[i - 1][0].name.slice(0, 50)
                    : groups[i - 1][0].name
                }}</span
              >
            </div>
            <div class="multi-price-barcode">
              <vue-qrcode
                :value="`${groups[i - 1][0].sku}&${
                  groups[i - 1][0].last_price_change
                }`"
                :width="60"
                :margin="0"
                :scale="0"
              ></vue-qrcode>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <v-row
      v-else-if="label_type == 24"
      justify="center"
      class="d-flex align-center"
    >
      <div
        style="height: 30cm; width: 21cm"
        v-for="i in groups.length"
        v-bind:key="i"
      >
        <div class="text-center" style="margin-top: 26px">
          <p style="font-size: 72px" class="mt-6">Супер цена</p>
          <div style="border: 1px solid black; height: 650px" class="d-flex">
            <div style="width: 25%">
              <p style="font-size: 50px">От</p>
              <h2 style="font-size: 50px; margin-top: 5px">
                шт <span>{{ groups[i - 1][0].from1 }}</span>
              </h2>
              <h2 style="font-size: 50px; margin-top: 130px">
                шт <span>{{ groups[i - 1][0].from2 }}</span>
              </h2>
              <h2 style="font-size: 50px; margin-top: 150px">
                шт <span>{{ groups[i - 1][0].from3 }}</span>
              </h2>
            </div>
            <v-divider vertical></v-divider>
            <div style="width: 75%; margin-top: 10px; margin-bottom: 30px">
              <div class="d-flex justify-end mr-10">
                <h2 style="font-size: 130px">
                  {{ groups[i - 1][0].price_first1 }},{{
                    groups[i - 1][0].price_second1
                  }}
                </h2>
              </div>
              <div class="d-flex justify-end mr-10">
                <h2 style="font-size: 145px">
                  {{ groups[i - 1][0].price_first2 }},{{
                    groups[i - 1][0].price_second2
                  }}
                </h2>
              </div>
              <div class="d-flex justify-end mr-10">
                <h2 style="font-size: 155px">
                  {{ groups[i - 1][0].price_first3 }},{{
                    groups[i - 1][0].price_second3
                  }}
                </h2>
              </div>
            </div>
          </div>
          <div class="mx-2">
            <div class="d-flex align-center">
              <div style="width: 25%">
                <img :src="emailed_receipt" width="150" alt="" />
              </div>
              <div style="width: 80%">
                <div style="height: 300px">
                  <p style="font-size: 60px; line-height: 102.4%" class="my-4">
                    {{ groups[i - 1][0].name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div
                style="width: 30%; font-size: 25px"
                class="d-flex justify-start"
              >
                <p>{{ groups[i - 1][0].sku }}</p>
              </div>
              <div
                style="width: 75%; font-size: 25px"
                class="d-flex justify-end"
              >
                <p>{{ groups[i - 1][0].barcode }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-row>
  </v-app>
</template>


<script>
import VueBarcode from "vue-barcode";
import JsBarcode from "jsbarcode";
export default {
  name: "print-labels-all",
  data: () => ({
    emailed_receipt: localStorage.getItem("emailed_receipt"),
    printed_receipt: localStorage.getItem("printed_receipt"),

    // emailed_receipt: "",
    // printed_receipt: "",
    groups: [],
    image_url: [],
    latitude: [],
    rows_number: 8,
    columns_number: 3,
    height: "40px",
    page_style: {},
    pages: null,
  }),
  components: {
    barcode: VueBarcode,
  },
  computed: {
    label_type() {
      return this.$route.query.type ? +this.$route.query.type : 1;
    },
    service_name() {
      return this.$store.state.service_name;
    },
  },
  methods: {
    openPrintLabel(items) {
      this.groups = [];
      for (const item of items) {
        for (var i = 0; i < item.quality; i++) {
          if (this.groups.length == 0) {
            this.groups.push([]);
          }
          if (
            this.groups[this.groups.length - 1].length ==
            this.rows_number * this.columns_number
          ) {
            this.groups.push([]);
          }
          let prices = [];
          if (typeof item.prices != typeof []) {
            item.prices = [];
          }
          if (typeof item.price != typeof 5) {
            item.price = 0;
          }
          let prices_type = 0;

          // first
          if (item.prices.length > 0) {
            if (item.prices[0].price != 0) {
              prices_type += 1;
              prices.push(item.prices[0]);
            }
          } else {
            prices.push({ from: 0, price: item.price });
          }
          // second
          if (item.prices.length > 1) {
            prices.push(item.prices[1]);
            if (item.prices[1].from != 0) {
              prices_type += 1;
            }
          } else {
            prices.push({ from: 0, price: item.price });
          }
          // third
          if (item.prices.length > 2) {
            prices.push(item.prices[2]);
            if (item.prices[2].from != 0) {
              prices_type += 1;
            }
          } else {
            prices.push({ from: 0, price: item.price });
          }

          if (prices.length < 3) {
            prices.push({ from: 0, price: item.price });
          }

          if (prices.length < 3) {
            prices.push({ from: 0, price: item.price });
          }

          if (prices_type == 0) {
            prices_type = 1;
          }

          let code = item.code;
          if (
            [8].includes(this.label_type) ||
            [12].includes(this.label_type) ||
            [29].includes(this.label_type) ||
            [20].includes(this.label_type) ||
            [30].includes(this.label_type)
          ) {
            code = ("00000" + item.code).slice(-5);
          }
          if (this.label_type === 5 && code <= 0) {
            code = "00000";
          }
          this.groups[this.groups.length - 1].push({
            name: item.name,
            category_name: item.category_name,
            price: item.price ? item.price.toLocaleString() : item.price,
            price_first: item.price
              ? Math.floor(item.price / 1000)
              : item.price,
            price_second: item.price
              ? item.price.toLocaleString().slice(-3)
              : item.price,
            code: code,
            sku: item.sku,
            last_price_change: item.last_price_change,
            barcode: item.barcode,
            prices_type: prices_type,
            from1: prices[0].from,
            from2: prices[1].from,
            from3: prices[2].from,
            price_first1: prices[0].price
              ? Math.floor(prices[0].price / 1000)
              : prices[0].price,
            price_second1: prices[0].price
              ? prices[0].price.toLocaleString().slice(-3)
              : prices[0].price,
            price_first2: prices[1].price
              ? Math.floor(prices[1].price / 1000)
              : prices[1].price,
            price_second2: prices[1].price
              ? prices[1].price.toLocaleString().slice(-3)
              : prices[1].price,
            price_first3: prices[2].price
              ? Math.floor(prices[2].price / 1000)
              : prices[2].price,
            price_second3: prices[2].price
              ? prices[2].price.toLocaleString().slice(-3)
              : prices[2].price,
          });
        }
      }
      while (
        this.groups[this.groups.length - 1].length !=
        this.columns_number * this.rows_number
      ) {
        this.groups[this.groups.length - 1].push(null);
      }
      setTimeout(() => {
        var all = document.querySelectorAll("svg.vue-barcode-element");
        for (var j = 0; j < all.length; j++) {
          all[j].setAttribute("width", "100%");
        }
        for (const ind in this.groups) {
          for (const indd in this.groups[ind]) {
            if (
              (this.groups[ind][indd] && this.label_type == 4) ||
              this.label_type == 5 ||
              this.label_type == 8 ||
              this.label_type == 7 ||
              this.label_type == 9 ||
              this.label_type == 12 ||
              this.label_type == 13 ||
              this.label_type == 14 ||
              this.label_type == 15 ||
              this.label_type == 16 ||
              this.label_type == 17 ||
              this.label_type == 19 ||
              this.label_type == 20 ||
              this.label_type == 21 ||
              this.label_type == 22 ||
              this.label_type == 25 ||
              this.label_type === 26 ||
              this.label_type === 27 ||
              this.label_type === 28 ||
              this.label_type == 23 ||
              this.label_type == 29 ||
              // this.label_type == 30 ||
              this.label_type == 31
              // this.label_type == 32
            ) {
              const conf = {
                height: this.label_type == 4 ? 25 : 20,
                width: this.label_type == 4 ? 1 : 1.5,
                displayValue:
                  this.label_type == 4 ||
                  this.label_type == 13 ||
                  this.label_type == 14 ||
                  this.label_type == 15 ||
                  this.label_type == 16,
                flat: true,
                fontSize: 10,
              };
              if (this.label_type == 4) {
                conf.height = 25;
                conf.width = 0.7;
              } else if (this.label_type == 6) {
                conf.height = 18;
                conf.width = 1.3;
              } else if (this.label_type == 25) {
                conf.height = 18;
                conf.width = 1.3;
              } else if (this.label_type == 7) {
                conf.height = 15;
                conf.width = 1.3;
              } else if (this.label_type == 27) {
                conf.height = 15;
                conf.width = 1.3;
              } else if (this.label_type == 9) {
                conf.height = 25;
                conf.width = 1.1;
                conf.margin = 0;
              } else if (this.label_type == 13) {
                conf.height = 20;
                conf.width = 1;
                conf.margin = 0;
              } else if (this.label_type == 14) {
                conf.height = 20;
                conf.width = 1.1;
                conf.margin = 0;
              } else if (this.label_type == 15) {
                conf.height = 20;
                conf.width = 0.8;
                conf.margin = 0;
              } else if (this.label_type == 16) {
                conf.height = 20;
                conf.width = 1.5;
                conf.margin = 0;
              } else if (this.label_type == 17) {
                conf.height = 32;
                conf.width = 1;
                conf.margin = 0;
              } else if (this.label_type == 18) {
                conf.height = 18;
                conf.width = 1.3;
              } else if (this.label_type == 19) {
                conf.height = 30;
                conf.width = 0.7;
                conf.margin = 0;
                conf.padding = 0;
              } else if (this.label_type == 20) {
                conf.height = 20;
                conf.width = 1.1;
                conf.margin = 0;
              } else if (this.label_type == 28) {
                conf.height = 20;
                conf.width = 1.1;
                conf.margin = 0;
              } else if (this.label_type == 22) {
                conf.height = 30;
                conf.width = 0.7;
                conf.margin = 0;
                conf.padding = 0;
              } else if (this.label_type == 23) {
                conf.height = 30;
                conf.width = 0.7;
                conf.margin = 0;
                conf.padding = 0;
              }
              // else if (this.label_type == 32) {
              //   conf.height = 1;
              //   conf.width = 1.3;
              // }
              if (this.groups[ind][indd] && this.label_type == 19) {
                // conf.format = "msi";
              }
              if (this.groups[ind][indd]) {
                try {
                  JsBarcode(
                    "#barcode" + ind + "_" + indd,
                    this.groups[ind][indd].code,
                    conf
                  );
                } catch (error) {
                  // console.log(error);
                }
              }
            }
          }
        }

        // this.printPdf();
      }, 10);
    },
    print() {
      var printer = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      var pages = [];
      if (!this.pages) {
        this.pages = document.querySelectorAll(".page");
        pages = this.pages;
      } else {
        pages = this.pages;
      }
      var content = "";
      for (var i = 0; i < pages.length; i++) {
        content += pages[i].outerHTML;
      }
      printer.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${content}
          </body>
        </html>`);
      printer.document.close();
      printer.focus();
      printer.print();
      printer.close();
      printer.save("print-label.pdf");
    },
    getLineHeightOfItem(item) {
      if (!item) {
        return 1;
      }
      if (!item.name) {
        return 1;
      }
      if (item.name.length > 30) {
        return 1;
      }
      return 2;
    },
  },
  mounted() {
    var all = document.querySelectorAll("svg.vue-barcode-element");
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute("width", "100%");
    }
    var label_type = this.$route.query.type ? +this.$route.query.type : 1;
    switch (label_type) {
      case 2: {
        this.page_style = {
          "grid-template-rows": "repeat(10, 29.7mm)",
        };
        this.height = "20px";
        this.rows_number = 10;
        break;
      }
      case 3: {
        this.page_style = {
          "grid-template-rows": "repeat(10, 29.7mm)",
          "grid-template-columns": "repeat(4, 52.5mm)",
        };
        this.height = "20px";
        this.rows_number = 10;
        this.columns_number = 4;
        break;
      }
      case 4: {
        this.page_style = {
          "grid-template-rows": "repeat(10, 29.7mm)",
          "grid-template-columns": "repeat(6, 35mm)",
        };
        this.height = "30px";
        this.rows_number = 10;
        this.columns_number = 6;
        break;
      }
      case 11: {
        this.page_style = {
          "grid-template-rows": "repeat(15, 19.8mm)",
          "grid-template-columns": "repeat(7, 30mm)",
        };
        this.height = "30px";
        this.rows_number = 15;
        this.columns_number = 7;
        break;
      }
      case 5: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 90mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 8: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 26: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 6: {
        this.page_style = {
          // "grid-template-rows": "repeat(1, 38mm)",
          // "grid-template-columns": "repeat(1, 90mm)",
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 90mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 25: {
        this.page_style = {
          // "grid-template-rows": "repeat(1, 38mm)",
          // "grid-template-columns": "repeat(1, 90mm)",
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 90mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 7: {
        this.page_style = {
          // "grid-template-rows": "repeat(1, 38mm)",
          // "grid-template-columns": "repeat(1, 90mm)",
          // "grid-template-rows": "repeat(1, 38mm)",
          // "grid-template-columns": "repeat(1, 90mm)",
        };
        // this.height = "20px";
        this.rows_number = 4;
        this.columns_number = 1;
        break;
      }
      case 9: {
        this.page_style = {
          "grid-template-rows": "repeat(11, 26.1mm)",
          "grid-template-columns": "repeat(3, 70mm)",
          // margin: "5mm",
        };
        // this.height = "20px";
        this.rows_number = 3;
        this.columns_number = 11;
        break;
      }
      case 10: {
        this.page_style = {
          "grid-template-rows": "repeat(10, 29.7mm)",
          "grid-template-columns": "repeat(4, 52.5mm)",
        };
        this.height = "20px";
        this.rows_number = 10;
        this.columns_number = 4;
        break;
      }
      case 12: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 13: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 57.68mm)",
          "grid-template-columns": "repeat(1, 36mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 14: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 40mm)",
          "grid-template-columns": "repeat(1, 65mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 15:
      case 16: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 30mm)",
          "grid-template-columns": "repeat(1, 55mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 17: {
        this.page_style = {
          "grid-template-rows": "repeat(7, 41mm)",
          "grid-template-columns": "repeat(3, 70mm)",
          // margin: "5mm",
        };
        // this.height = "20px";
        this.rows_number = 3;
        this.columns_number = 7;
        break;
      }
      case 18: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 40mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 19: {
        this.page_style = {};
        this.rows_number = 4;
        this.columns_number = 1;
        break;
      }
      case 20: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 20mm)",
          "grid-template-columns": "repeat(1, 30mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 28: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 30mm)",
          "grid-template-columns": "repeat(1, 20mm)",
        };
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 21: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 22: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 30mm)",
          "grid-template-columns": "repeat(1, 40mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 27: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 23: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 30mm)",
          "grid-template-columns": "repeat(1, 40mm)",
        };
        // this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      case 29: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      // case 30: {
      //   this.page_style = {
      //     "grid-template-rows": "repeat(1, 38mm)",
      //     "grid-template-columns": "repeat(1, 58mm)",
      //   };
      //   this.rows_number = 1;
      //   this.columns_number = 1;
      //   break;
      // }
      case 31: {
        this.page_style = {
          "grid-template-rows": "repeat(1, 38mm)",
          "grid-template-columns": "repeat(1, 58mm)",
        };
        this.height = "20px";
        this.rows_number = 1;
        this.columns_number = 1;
        break;
      }
      // case 32: {
      //   this.page_style = {
      //     // "grid-template-rows": "repeat(1, 38mm)",
      //     // "grid-template-columns": "repeat(1, 90mm)",
      //     "grid-template-rows": "repeat(1, 80mm)",
      //     "grid-template-columns": "repeat(1, 38mm)",
      //   };
      //   // this.height = "20px";
      //   this.rows_number = 1;
      //   this.columns_number = 1;
      //   break;
      // }
    }
    var items = localStorage.getItem("print-items");
    items = JSON.parse(items);

    this.openPrintLabel(items);
  },
};
</script>

<style>
/*
* multi price styles
*/
.v-application p {
  margin-bottom: 0px !important;
}
.multi_price_page {
  width: 38mm;
  min-height: 85mm;
  /* width: 85mm;
  min-height: 38mm; */
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(1, 85mm);
  grid-template-columns: repeat(1, 38mm);
  /* grid-template-rows: repeat(1, 38mm);
  grid-template-columns: repeat(1, 85mm); */
}

.multi_price_page32 {
  width: 80mm;
  height: 38mm;
  /* width: 85mm;
  min-height: 38mm; */
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  margin-bottom: 8px;
  grid-template-rows: repeat(1, 80mm);
  grid-template-columns: repeat(1, 38mm);
  /* grid-template-rows: repeat(1, 38mm);
  grid-template-columns: repeat(1, 85mm); */
}

.multi-price-grid-container-row {
  display: grid;
  grid-template-columns: auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  width: 85mm;
  transform: rotate(90deg);
}
.multi-price-grid-container-col32 {
  display: grid;
  grid-template-columns: auto;
  font-family: "Calibri";
  width: 80mm;
  height: 38mm;

  /* border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black; */
  /* border-bottom: 1px solid black; */
  /* transform: rotate(90deg); */
}

.multi-price-grid-container-row-simple {
  display: grid;
  grid-template-columns: auto;
}

.multi-price-grid-container-column-simple {
  display: grid;
  width: 37mm;
  grid-template-columns: auto auto;
}
.multi-price-grid-container-column-simple32 {
  display: grid;
  width: 80mm;
  height: 38mm !important;
  grid-template-columns: auto auto;
}

.multi-price-grid-container-column {
  display: grid;
  grid-template-columns: auto auto;
  border-left: solid black 0.5px;
  border-bottom: solid black 0.5px;
  border-right: solid black 0.5px;
}

.multi-price-grid-header {
  display: grid;
  grid-template-columns: auto auto auto;
  height: 5mm;
  /* width: 85mm; */
  border: 1px solid black;
  font-weight: 500;
  font-size: 12px;
}

.multi-price-item-count {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  width: 12mm;
  padding-top: 2mm;
  border-right: solid 1px black;
}

.multi-price-item-price {
  font-weight: bold;
  font-size: 26px;
  padding-left: 5mm;
  padding-top: 1mm;
  width: 36mm;
  line-height: 1.4;
}

.multi-price-price-tail {
  font-size: 18px;
  position: absolute;
  margin-top: 2px;
  margin-left: 2px;
}

.multi-price-item-count1 {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  width: 12mm;
  height: 33mm;
  padding-top: 2mm;
  border-right: solid 1px black;
  line-height: 4.6;
}

.multi-price-item-price1 {
  font-weight: bold;
  font-size: 30px;
  padding-left: 5mm;
  padding-top: 1mm;
  width: 36mm;
  line-height: 4;
}

.multi-price-price-tail1 {
  font-size: 20px;
  position: absolute;
  margin-top: 15px;
  margin-left: 2px;
}

.multi-price-item-count2 {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  width: 12mm;
  height: 16.5mm;
  padding-top: 2mm;
  border-right: solid 1px black;
  line-height: 2.3;
}

.multi-price-item-price2 {
  font-weight: bold;
  font-size: 24px;
  padding-left: 5mm;
  padding-top: 1mm;
  width: 36mm;
  line-height: 2.3;
}

.multi-price-price-tail2 {
  font-size: 18px;
  position: absolute;
  margin-top: 5px;
}

.multi-price-amount {
  font-weight: bold;
}

.multi-price-item-name {
  width: 37mm;
  height: 17mm;
  padding-left: 1mm;
  padding-right: 1mm;
  padding: auto;
  text-align: center;
  font-weight: 500;
  display: table;
}
.multi-price-barcode {
  width: 37mm;
  height: 18mm;
  padding: auto;
  text-align: center;
  vertical-align: middle;
  font-weight: 300;
}
/** */

/*
* multi price styles
*/
.multi_price_small_page {
  width: 40mm;
  min-height: 58mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(1, 58mm);
  grid-template-columns: repeat(1, 40mm);
  border: solid black 1px;
}

.multi-price-small-grid-container-row {
  display: grid;
  grid-template-columns: auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  width: 85mm;
  transform: rotate(90deg);
  margin-top: 160px;
  margin-left: -12px;
}

.multi-price-small-grid-container-row-simple {
  display: grid;
  grid-template-columns: auto;
}

.multi-price-small-grid-container-column-simple {
  display: grid;
  width: 37mm;
  grid-template-columns: auto auto;
}

.multi-price-small-grid-container-column {
  display: grid;
  grid-template-columns: auto auto;
  border-left: solid black 0.5px;
  border-bottom: solid black 0.5px;
  border-right: solid black 0.5px;
}

.multi-price-small-grid-header {
  display: grid;
  grid-template-columns: auto auto auto;
  height: 5mm;
  border: 1px solid black;
  font-weight: 500;
  font-size: 12px;
}

.multi-price-small-item-count {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  width: 8mm;
  padding-top: 2mm;
  border-right: solid 1px black;
}

.multi-price-small-item-price {
  font-weight: bold;
  font-size: 26px;
  padding-left: 5mm;
  padding-top: 1mm;
  width: 24mm;
  line-height: 1.4;
}

.multi-price-small-price-tail {
  font-size: 18px;
  position: absolute;
  margin-top: 2px;
  margin-left: 2px;
}

.multi-price-small-item-count1 {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  width: 8mm;
  height: 33mm;
  padding-top: 2mm;
  border-right: solid 1px black;
  line-height: 4.6;
}

.multi-price-small-item-price1 {
  font-weight: bold;
  font-size: 30px;
  padding-left: 5mm;
  padding-top: 1mm;
  width: 24mm;
  line-height: 4;
}

.multi-price-small-price-tail1 {
  font-size: 20px;
  position: absolute;
  margin-top: 15px;
  margin-left: 2px;
}

.multi-price-small-item-count2 {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  width: 8mm;
  height: 16.5mm;
  padding-top: 2mm;
  border-right: solid 1px black;
  line-height: 2.3;
}

.multi-price-small-item-price2 {
  font-weight: bold;
  font-size: 24px;
  padding-left: 5mm;
  padding-top: 1mm;
  width: 24mm;
  line-height: 2.3;
}

.multi-price-small-price-tail2 {
  font-size: 18px;
  position: absolute;
  margin-top: 5px;
}

.multi-price-small-amount {
  font-weight: bold;
}

.multi-price-small-item-name {
  width: 25mm;
  max-width: 25mm;
  height: 17mm;
  max-height: 17mm;
  text-align: center;
  font-weight: 500;
  overflow: hidden;
  padding: 0;
}
.multi-price-small-item-name-box {
  width: 25mm;
  max-width: 25mm;
  height: 17mm;
  max-height: 17mm;
  padding-left: 2mm;
  padding-right: 2mm;
  margin: 0;
  overflow: hidden;
  text-align: center;
  display: table;
}
.multi-price-small-barcode {
  width: 24mm;
  height: 18mm;
  padding: auto;
  text-align: center;
  vertical-align: middle;
  font-weight: 300;
}
/** */
/** Label 4X styles */
.label_4x_page {
  width: 76mm;
  min-height: 38mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  border-radius: 3px;;
  grid-template-columns: repeat(4, 19mm);
}

.label-4x-row {
  display: grid;
  grid-template-columns: auto;
  height: 19mm;
  width: 38mm;
  transform: rotate(90deg);
}

.label-4x-row-name {
  text-align: center;
  line-height: 2.5;
  height: 10mm;
  width: 38mm;
  overflow: hidden;
  padding-right: 3mm;
  padding-left: 3mm;
  /* max-width: 35mm; */
  /* text-overflow: ellipsis; */
}

.label-4x-row-barcode {
  text-align: center;
  line-height: 2.5;
  height: 10mm;
  width: 38mm;
}

.label-4x-item-name {
  text-align: left;
  line-height: 1;
  width: 38mm;
  overflow: hidden;
  margin: 0;
  padding: 0;
  font-size: 8px;
  max-height: 6mm;
}

.label-4x-item-name-own {
  width: 38mm;
  text-align: left;
  line-height: 1;
  overflow: hidden;
  margin: 0;
  padding: 0;
  padding-right: 3mm;
  padding-left: 3mm;
  font-size: 8px;
  max-height: 6mm;
}

.label-4x-item-barcode {
  text-align: right;
  height: 5mm;
  min-height: 5mm;
  width: 38mm;
  margin: 0;
  padding: 0;
  padding-right: 3mm;
  padding-top: 0mm;
}

.label-4x-item-price {
  text-align: left;
  line-height: 2;
  padding-left: 3mm;
  height: 6mm;
  min-height: 6mm;
  width: 38mm;
  font-weight: bold;
}

/**Godex Label A4 3x12 <start--->*/
.multi-godex-body {
  display: grid;
  grid-template-columns: auto auto;
  height: 26.1mm;
  width: 70mm;
  border-bottom: black solid 1px;
  border-right: black solid 1px;
}

.multi-godex-body-left {
  display: grid;
  grid-template-columns: auto;
  height: 26.1mm;
  width: 30mm;
}

.multi-godex-body-right {
  display: grid;
  grid-template-columns: auto;
  height: 26.1mm;
  width: 40mm;
}

.multi-godex-body-left-name {
  height: 11mm;
  width: 30mm;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

.multi-godex-body-left-sku {
  height: 6.1mm;
  width: 30mm;
  padding-left: 2mm;
}

.multi-godex-body-left-date {
  height: 6.5mm;
  width: 28mm;
  text-align: center;
  border: solid black 0.5px;
}

.multi-godex-body-right-price {
  height: 15mm;
  width: 40mm;
}

.multi-godex-body-right-barcode {
  height: 10mm;
  width: 40mm;
  text-align: center;
  padding-top: 2mm;
  padding-right: 2mm;
}
/**<---end> */

/**Godex Label A4 3x7 <start--->*/
.multi-godex-body-3-7 {
  display: grid;
  grid-template-columns: auto auto;
  height: 41mm;
  width: 70mm;
  border-bottom: black solid 1px;
  border-right: black solid 1px;
}

.multi-godex-body-left-3-7 {
  display: grid;
  grid-template-columns: auto;
  height: 41mm;
  width: 35mm;
}

.multi-godex-body-right-3-7 {
  display: grid;
  grid-template-columns: auto;
  height: 41mm;
  width: 35mm;
}

.multi-godex-body-left-name-3-7 {
  height: 33mm;
  width: 35mm;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 22px;
  padding-left: 2mm;
  position: relative;
  padding-top: 20px;
}

.multi-godex-body-left-name-3-7-vertical-center {
  margin: auto;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 30mm;
  height: 33mm; */
}

.multi-godex-body-left-sku-3-7 {
  height: 13mm;
  width: 35mm;
  padding-left: 2mm;
  font-size: 20px;
}

.multi-godex-body-left-date {
  height: 6.5mm;
  width: 28mm;
  text-align: center;
  border: solid black 0.5px;
}

.multi-godex-body-right-price-3-7 {
  padding-top: 20px;
  height: 25mm;
  width: 35mm;
}

.multi-godex-body-right-barcode-3-7 {
  height: 10mm;
  width: 35mm;
  text-align: center;
  padding-top: 2mm;
  padding-right: 2mm;
}
/**<---end> */
.rotate90 {
  transform: rotate(90deg);
}
.bottom_border {
  border-bottom: 1px solid black;
}
.small_page {
  width: 38mm;
  min-height: 85mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  grid-template-rows: repeat(1, 85mm);
  grid-template-columns: repeat(1, 38mm);
}

.small_page8 {
  width: 38mm;
  min-height: 58mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  grid-template-rows: repeat(1, 58mm);
  grid-template-columns: repeat(1, 38mm);
}
.small_page30 {
  width: 58mm;
  min-height: 38mm;
  margin: 0px auto;
  margin-top: 75px;
  background: white;
  box-sizing: border-box;
  display: grid;
  transform: rotate(90deg);
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  grid-template-rows: repeat(1, 58mm);
  grid-template-columns: repeat(1, 38mm);
}

.small_page27 {
  width: 38mm;
  min-height: 58mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  grid-template-rows: repeat(1, 58mm);
  grid-template-columns: repeat(1, 38mm);
}
.small-page-name-box {
  min-height: 17mm;
  max-height: 17mm;
  overflow: hidden;
  margin-top: 0.5mm;
}

.small-page-name {
  width: 58mm;
  height: 17mm;
  padding-left: 1mm;
  padding-right: 1mm;
  padding: auto;
  text-align: center;
  font-weight: 500;
  display: table;
}

.small_page12 {
  width: 58mm;
  min-height: 38mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  display: grid;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  grid-template-rows: repeat(1, 38mm);
  grid-template-columns: repeat(1, 58mm);
}
.small_page13 {
  width: 36mm;
  min-height: 57.68mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  /* border: 0.3px solid black; */
  grid-template-rows: repeat(1, 57.68mm);
  grid-template-columns: repeat(1, 36mm);
}

.category_name_and_sku_13 {
  width: 57.5mm;
  min-height: 6mm;
  max-height: 6mm;
  display: grid;
  grid-template-columns: auto auto;
  padding-left: 2mm;
  padding-right: 2mm;
}
.category_name_13 {
  width: 27mm;
  min-height: 6mm;
  max-height: 6mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sku_13 {
  width: 27mm;
  min-height: 6mm;
  max-height: 6mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item_name_13 {
  width: 57.5mm;
  min-height: 8mm;
  max-height: 8mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 2mm;
  padding-right: 2mm;
  text-align: center;
  line-height: 1.3;
  vertical-align: middle;
}
.item_price_13 {
  width: 57.5mm;
  min-height: 12mm;
  max-height: 12mm;
  padding-left: 2mm;
  padding-right: 2mm;
}
.item_footer_13 {
  width: 57.5mm;
  min-height: 10mm;
  max-height: 10mm;
  padding-left: 2mm;
  padding-right: 2mm;
  display: grid;
  grid-template-columns: auto auto;
}
.small_page14 {
  width: 65mm;
  min-height: 40mm;
  max-height: 40mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border: solid black 1px;
  grid-template-rows: repeat(1, 40mm);
  grid-template-columns: repeat(1, 65mm);
}

.category_name_and_sku_14 {
  width: 65mm;
  min-height: 10mm;
  max-height: 10mm;
  display: grid;
  grid-template-columns: auto auto;
  padding-left: 2mm;
  padding-right: 2mm;
}

.category_name_14 {
  width: 43mm;
  min-height: 10mm;
  max-height: 10mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  line-height: 1.8;
}

.sku_14 {
  width: 18mm;
  min-height: 10mm;
  max-height: 10mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  line-height: 1.8;
}

.item_name_14 {
  width: 65mm;
  min-height: 15mm;
  max-height: 15mm;
  padding-left: 2mm;
  padding-right: 2mm;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item_footer_14 {
  width: 65mm;
  min-height: 15mm;
  max-height: 15mm;
  padding-left: 2mm;
  padding-right: 2mm;
  display: grid;
  grid-template-columns: auto auto;
}
.item_footer_left_14 {
  width: 38mm;
  min-height: 15mm;
  max-height: 15mm;
  display: grid;
}
.item_footer_right_14 {
  width: 23mm;
  min-height: 15mm;
  max-height: 15mm;
  display: grid;
}
.item_footer_left_date_14 {
  width: 38mm;
  font-size: 12px;
  text-align: center;
  min-height: 5mm;
  max-height: 5mm;
}
.item_footer_left_barcode_14 {
  width: 38mm;
  min-height: 10mm;
  max-height: 10mm;
  text-align: center;
  max-width: 38;
  min-width: 38;
}
.small_page15 {
  width: 55mm;
  min-height: 30mm;
  max-height: 30mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  grid-template-rows: repeat(1, 30mm);
  grid-template-columns: repeat(1, 55mm);
  border: solid black 1px;
}
.category_name_and_sku_15 {
  width: 55mm;
  min-height: 7mm;
  max-height: 7mm;
  display: grid;
  grid-template-columns: auto auto;
  padding-left: 2mm;
  padding-right: 2mm;
}
.category_name_15 {
  width: 36mm;
  min-height: 7mm;
  max-height: 7mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.8;
}
.sku_15 {
  width: 15mm;
  min-height: 7mm;
  max-height: 7mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  line-height: 1.8;
}
.item_name_15 {
  width: 55mm;
  /* min-height: 9mm;
  max-height: 9mm; */
  padding-left: 2mm;
  padding-right: 2mm;
  text-align: center;
  margin-top: 0.5mm;
  margin-bottom: 0.6mm;
  line-height: 0.9;
  /* -webkit-box-orient: vertical; */
  overflow: hidden;
}
.item_footer_15 {
  width: 55mm;
  min-height: 13mm;
  max-height: 13mm;
  padding-left: 2mm;
  padding-right: 2mm;
  display: grid;
  grid-template-columns: auto auto;
}
.item_footer_left_15 {
  width: 29mm;
  min-height: 14mm;
  max-height: 14mm;
  display: grid;
}
.item_footer_left_date_15 {
  width: 29mm;
  font-size: 8px;
  text-align: left;
  min-height: 3mm;
  max-height: 3mm;
}
.item_footer_left_barcode_15 {
  width: 29mm;
  min-height: 11mm;
  max-height: 11mm;
  text-align: left;
  max-width: 33mm;
  min-width: 33mm;
}
.item_footer_right_15 {
  width: 21mm;
  min-height: 14mm;
  max-height: 14mm;
  display: grid;
}
.category_name_16 {
  width: 36mm;
  min-height: 7mm;
  max-height: 7mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  line-height: 1.8;
}
.item_footer_left_16 {
  width: 55mm;
  min-height: 14mm;
  max-height: 14mm;
  display: grid;
}
.item_footer_left_date_16 {
  width: 55mm;
  font-size: 8px;
  text-align: left;
  min-height: 3mm;
  max-height: 3mm;
}
.item_footer_left_barcode_16 {
  width: 55mm;
  min-height: 20mm;
  max-height: 20mm;
  text-align: center;
  max-width: 33mm;
  min-width: 33mm;
}

.small_page20 {
  width: 30mm;
  min-height: 20mm;
  max-height: 20mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border: solid black 1px;
  page-break-after: always;
  grid-template-rows: repeat(1, 20mm);
  grid-template-columns: repeat(1, 30mm);
}

.small_page28 {
  width: 30mm;
  /* min-height: 25.5mm; */
  /* max-height: 25.5mm; */
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border: solid black 1px;
  grid-template-rows: repeat(1, 30mm);
  grid-template-columns: repeat(1, 20mm);
}
.category_name_and_sku_20 {
  width: 65mm;
  min-height: 10mm;
  max-height: 10mm;
  display: grid;
  grid-template-columns: auto auto;
  padding-left: 2mm;
  padding-right: 2mm;
}

.category_name_20 {
  width: 43mm;
  min-height: 10mm;
  max-height: 10mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  line-height: 1.8;
}

.sku_20 {
  width: 18mm;
  min-height: 10mm;
  max-height: 10mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  line-height: 1.8;
}

.item_name_20 {
  max-width: 29mm;
  min-height: 12mm;
  max-height: 12mm;
  padding-left: 0mm;
  padding-right: 1mm;
  padding-top: 1mm;
  text-align: center;
  -webkit-line-clamp: 2;
  line-height: 1.2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item_name_20_box {
  width: 28mm;
  min-height: 10mm;
  max-height: 10mm;
  text-align: center;
  -webkit-line-clamp: 2;
  line-height: 1.2;
  -webkit-box-orient: vertical;
  display: table;
}
.item_name_20_snap {
  display: table-cell;
  vertical-align: middle;
  font-size: 8px;
}
.item_footer_20 {
  width: 65mm;
  min-height: 15mm;
  max-height: 15mm;
  padding-left: 2mm;
  padding-right: 2mm;
  display: grid;
  grid-template-columns: auto auto;
}
.item_footer_left_20 {
  width: 38mm;
  min-height: 15mm;
  max-height: 15mm;
  display: grid;
}
.item_footer_right_20 {
  width: 23mm;
  min-height: 15mm;
  max-height: 15mm;
  display: grid;
}
.item_footer_left_date_20 {
  width: 38mm;
  font-size: 12px;
  text-align: center;
  min-height: 5mm;
  max-height: 5mm;
}
.item_footer_left_barcode_20 {
  width: 28mm;
  min-height: 8mm;
  max-height: 8mm;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 38;
  min-width: 38;
}

.item_footer_left_barcode_28 {
  width: 30mm;
  min-height: 5mm;
  max-height: 5mm;
  text-align: center;
  max-width: 38;
  min-width: 38;
}

.small_page22 {
  width: 40mm;
  min-height: 30mm;
  max-height: 30mm;
  margin: 0mm auto;
  background: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border: solid black 1px;
  grid-template-rows: repeat(1, 30mm);
  grid-template-columns: repeat(1, 40mm);
}

.category_name_and_sku_22 {
  width: 65mm;
  min-height: 10mm;
  max-height: 10mm;
  display: grid;
  grid-template-columns: auto auto;
  padding-left: 2mm;
  padding-right: 2mm;
}

.category_name_22 {
  width: 43mm;
  min-height: 10mm;
  max-height: 10mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  line-height: 1.8;
}

.sku_22 {
  width: 40mm;
  min-height: 7mm;
  max-height: 7mm;
  padding-left: 5mm;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1.8;
}

.item_name_22 {
  max-width: 40mm;
  min-height: 10mm;
  max-height: 10mm;
  padding-left: 1mm;
  padding-right: 1mm;
  padding-top: 2mm;
  padding-bottom: 2mm;
  text-align: center;
  -webkit-line-clamp: 2;
  line-height: 1.2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
}
.item_name_22_box {
  width: 40mm;
  min-height: 10mm;
  max-height: 10mm;
  text-align: center;
  -webkit-line-clamp: 2;
  line-height: 1.2;
  -webkit-box-orient: vertical;
  display: table;
}
.item_name_22_snap {
  display: table-cell;
  vertical-align: middle;
}
.item_footer_22 {
  width: 65mm;
  min-height: 15mm;
  max-height: 15mm;
  padding-left: 2mm;
  padding-right: 2mm;
  display: grid;
  grid-template-columns: auto auto;
}
.item_footer_left_22 {
  width: 38mm;
  min-height: 15mm;
  max-height: 15mm;
  display: grid;
}
.item_footer_right_22 {
  width: 23mm;
  min-height: 15mm;
  max-height: 15mm;
  display: grid;
}
.item_footer_left_date_22 {
  width: 38mm;
  font-size: 12px;
  text-align: center;
  min-height: 5mm;
  max-height: 5mm;
}
.item_footer_left_barcode_22 {
  width: 40mm;
  min-height: 12mm;
  max-height: 12mm;
  text-align: center;
  max-width: 38;
  min-width: 38;
  padding-top: 2mm;
}
.page {
  width: 21cm;
  min-height: 29.7cm;
  margin: 1cm auto;
  background: white;
  border-top: 1px solid black;
  border-left: 1px solid black;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(8, 37mm);
  grid-template-columns: repeat(3, 70mm);
}

.page2 {
  width: 21cm;
  min-height: 29.7cm;
  margin-top: 20px;
  margin: 1cm auto;
  background: white;
  border-top: 1px solid black;
  border-left: 1px solid black;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(8, 37mm);
  grid-template-columns: repeat(3, 70mm);
}

.page_content {
  box-sizing: border-box;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}
.page_content2 {
  padding-top: 5px;
  box-sizing: border-box;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}

.page--header {
  text-align: center;
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 0;
}
.page--header2 {
  text-align: center;
  font-size: 12px;
  margin-top: 0px;
  margin-bottom: 0;
}

@page {
  size: auto;
  margin: 0;
}

@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .small_page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .small_page8 {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .small_page30 {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .small_page27 {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .multi_price_page {
    page-break-after: always;
    float: none;
  }
  .multi_price_page32 {
    page-break-after: always;
    float: none;
  }

  .multi_price_small_page {
    page-break-after: always;
  }

  .label_4x_page {
    margin: auto;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .small_page14 {
    margin: auto;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .small_page15 {
    margin: auto;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .small_page20 {
    margin: auto;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .small_page28 {
    margin: auto;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
  .small_page22 {
    margin: auto;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
</style>
